import { inject, injectable } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type RouterService from '@/services/route/routerService'
import type TicketInboxService from '@/services/domain/tickets/inboxes/ticketInboxService'
import TicketInbox from '@/data/models/domain/tickets/TicketInbox'
import type { Route } from '@/services/route/types'
import type ResolverService from '@/services/resolvers/resolverService'
import { UserSettingsRoutes } from '@/routes/user/settings'

@injectable()
export default class SettingsTicketsResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.TicketInboxService) protected readonly ticketInboxService: TicketInboxService,
    @inject(SERVICE_TYPES.RouterService) protected readonly routerService: RouterService,
    @inject(SERVICE_TYPES.ResolverService) protected readonly resolverService: ResolverService,
  ) {}

  public async resolve(): Promise<void> {
    await this.resolveInboxes()

    if (!this.ticketInboxService.hasInboxes()) {
      await this.routerService.replace({
        name: UserSettingsRoutes.Tickets,
      })
    }
  }

  protected resolveInboxes(route?: Route, fromRoute?: Route) {
    return this.resolverService.resolveComponent(
      [
        {
          service: 'ModelResolver',
          params: [TicketInbox],
        },
      ],
      route,
      fromRoute,
    )
  }
}
